export default __webpack_public_path__ + "static/media/mac-cloudos.e815271c.jpg";